import React from 'react'
import PropTypes from 'prop-types'
import Grid from '@material-ui/core/Grid'
import { Link } from 'react-router-dom'
import FadeIn from '../../../molecules/Transitions/FadeIn'
import OpalTile from '../../../opal/OpalTile'

function DataHomeIndexView ({ root }) {
  return (
    <FadeIn style={{ maxWidth: '1280px', margin: '0 auto' }}>
      <Grid container spacing={1}>
        <Grid item xs={12} md={3}>
          <Link to={`${root}/nlq`}>
            <OpalTile size='xl' className='opal-selectable font-size-lg text-center p-sm'>
              Natural Language Query (v1)
            </OpalTile>
          </Link>
        </Grid>
        <Grid item xs={12} md={3}>
          <Link to={`${root}/nlq2`}>
            <OpalTile size='xl' className='opal-selectable font-size-lg text-center p-sm'>
              Natural Language Query (v2)
            </OpalTile>
          </Link>
        </Grid>
        <Grid item xs={12} md={3}>
          <Link to={`${root}/abundance-designer`}>
            <OpalTile size='xl' className='opal-selectable font-size-lg text-center p-sm'>
              Abundance Engine Designer
            </OpalTile>
          </Link>
        </Grid>
      </Grid>
    </FadeIn>
  )
}

DataHomeIndexView.propTypes = {
  root: PropTypes.any
}

export default DataHomeIndexView
